/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M18.243 15.333c0 .69.56 1.25 1.25 1.25a.833.833 0 0 1 0 1.667h-15a.833.833 0 1 1 0-1.667c.69 0 1.25-.56 1.25-1.25v-4.051A6.63 6.63 0 0 1 11.16 4.56V2.833a.833.833 0 1 1 1.666 0v1.728a6.63 6.63 0 0 1 5.417 6.72v4.052ZM10.13 19.5h3.726c.107 0 .196.08.207.185a2.083 2.083 0 1 1-4.14 0 .208.208 0 0 1 .207-.185Z"
})), "0 0 24 24", "Notification");